import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import LeftTree from './components/left-tree.vue';
import RightPreview from './components/right-preview.vue';
import MsgAlarm from '@blade-sxp/monitor-center/pages/components/msg-alarm/index.vue';
import Carousel from '@blade-sxp/monitor-center/pages/components/carousel/index.vue';
import ControlPage from '@blade-sxp/monitor-center/store/index';
import { ControlModule } from '@blade-sxp/monitor/store/control';
let default_1 = class extends Vue {
    singleScreenIndex = 0; // 选中的屏幕
    selectedDeviced = ['', '', '', '']; // 播放的设备id集合
    dragDevicedId = ''; // 拖拽播放的设备id
    dragDevicedName = ''; // 拖拽播放的设备name
    dragDevicedType = ''; // 拖拽播放的设备类型
    isDragStyle = false;
    height = 0;
    selectedDevicedArr = [
        { title: '', rtsp: '', id: '', taskId: '', extendData: {}, polygonData: [], keyId: '', zoomRatio: 16 / 9 },
        { title: '', rtsp: '', id: '', taskId: '', extendData: {}, polygonData: [], keyId: '', zoomRatio: 16 / 9 },
        { title: '', rtsp: '', id: '', taskId: '', extendData: {}, polygonData: [], keyId: '', zoomRatio: 16 / 9 },
        { title: '', rtsp: '', id: '', taskId: '', extendData: {}, polygonData: [], keyId: '', zoomRatio: 16 / 9 },
    ]; // 播放视频流集合
    changeHeightVideo(height) {
        this.height = height;
    }
    created() {
        const selectedDevicedArr = ControlPage.selectedDevicedArr || [];
        const index = selectedDevicedArr?.findIndex((item) => {
            return item.id !== '';
        });
        if (index !== -1) {
            this.selectedDevicedArr = selectedDevicedArr;
            this.selectedDeviced = ControlPage.selectedDeviced || ['', '', '', ''];
            this.singleScreenIndex = ControlPage.singleScreenIndex;
        }
    }
    mounted() {
        this.$refs.msgAlarm?.getTaskList();
    }
    beforeDestroy() {
        ControlPage.updateSingleScreenIndex(this.singleScreenIndex);
        ControlModule.clearSelectMap();
    }
};
default_1 = __decorate([
    Component({
        name: 'monitorCenter',
        components: {
            LeftTree,
            RightPreview,
            MsgAlarm,
            Carousel,
        },
    })
], default_1);
export default default_1;
